import { SET_STOCK } from '../actions/types/index';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_STOCK:
      return action.payload;
    default:
      return state;
  }
};
